import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import type { Schedule } from "@/pages/human-resources/time-management/business/schedule/Schedule.ts";
import type { ValidateSchedulesIn } from "@/pages/human-resources/time-management/endpoints/schedules/inout/ValidateSchedulesIn.ts";
import { validateSchedules } from "@/pages/human-resources/time-management/endpoints/schedules/SchedulesEndpoints.ts";
import useScheduleDataStateDispatch from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/useScheduleDataStateDispatch.ts";
import useScheduleReferenceData from "@/pages/human-resources/time-management/schedules/reference-provider/useScheduleReferenceData.ts";
import { useContext } from "react";
import { ScheduleValidationSnackBarStateDispatchContext } from "@/pages/human-resources/time-management/components/schedule-validation/ScheduleValidationSnackbarProvider.tsx";

export default function useValidateSchedules(): UseMutationResult<
  void,
  Error,
  Schedule[]
> {
  const {
    siteData: { siteId },
  } = useScheduleReferenceData();
  const dataStateDispatch = useScheduleDataStateDispatch();
  const successDispatch = useContext(
    ScheduleValidationSnackBarStateDispatchContext,
  );

  return useMutation({
    mutationFn: async (schedules: Schedule[]) => {
      const input: ValidateSchedulesIn = {
        siteId: parseInt(siteId),
        scheduleIds: schedules
          .map((s) => parseInt(s.id ?? s.publishedId ?? "0"))
          .filter((id) => id !== 0),
      };
      if (input.scheduleIds.length === 0) {
        return;
      }
      dataStateDispatch({
        type: "employeesMarkStale",
        employeesIds: schedules.map((s) => s.employeeId),
      });

      if (await validateSchedules(input)) {
        successDispatch({ type: "open", validatedCount: schedules.length });
      }
      dataStateDispatch({ type: "schedulesMarkStale" });
    },
  });
}
